import { z } from "zod";

export const passwordSchema = z
  .string()
  .min(8, "Must be at least 8 characters")
  .regex(/[a-z]/, "Must contain at least one lowercase letter")
  .regex(/[A-Z]/, "Must contain at least one uppercase letter")
  .regex(/\d/, "Must contain at least one number")
  .regex(/[^A-Za-z0-9]/, "Must contain at least one special character");

export const signUpFormSchema = z
  .object({
    fullName: z.string().min(1, { message: "Name is required" }),
    password: passwordSchema,
    passwordConfirmation: z.string().min(1, "Password is required"),
  })
  .refine((data) => data.password === data.passwordConfirmation, {
    message: "Passwords don't match",
    path: ["passwordConfirmation"],
  });

export type SignUpFormValuesType = z.infer<typeof signUpFormSchema>;

export const resetPasswordFormSchema = z
  .object({
    password: passwordSchema,
    passwordConfirmation: z.string().min(1, "Password is required"),
  })
  .refine((data) => data.password === data.passwordConfirmation, {
    message: "Passwords don't match",
    path: ["passwordConfirmation"],
  });

export type ResetPasswordFormValuesType = z.infer<
  typeof resetPasswordFormSchema
>;

export const loginFormSchema = z.object({
  email: z
    .string()
    .email("Please enter a valid email address.")
    .transform((email) => email.toLowerCase()),
  password: z.string().min(1, "Password is required"),
});

export type LoginFormValuesType = z.infer<typeof loginFormSchema>;

export const forgotPasswordFormSchema = z.object({
  email: z
    .string()
    .email("Please enter a valid email address.")
    .transform((email) => email.toLowerCase()),
});

export type ForgotPasswordFormValuesType = z.infer<
  typeof forgotPasswordFormSchema
>;

export const twoFactorAuthFormSchema = z.object({
  code: z.string(),
});

export type TwoFactorAuthFormValuesType = z.infer<
  typeof twoFactorAuthFormSchema
>;
